var _circle, _rect, _circle2, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagTurkDestination(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 55,
    fill: "#F1F1FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 8.5,
    width: 93,
    height: 93,
    rx: 46.5,
    stroke: "#5754E5",
    strokeOpacity: 0.15
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 46,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15692_297394",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 92,
    height: 92
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 101C80.4051 101 101 80.4051 101 55C101 29.5949 80.4051 9 55 9C29.5949 9 9 29.5949 9 55C9 80.4051 29.5949 101 55 101Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15692_297394)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15692_297394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4.5293 9H133.471V101H-4.5293V9Z",
    fill: "#E30A17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4879 55L80.2921 48.2411L67.4336 65.9373V44.0627L80.2921 61.7589L59.4879 55ZM60.9062 67.2989C58.2415 71.5098 54.2813 74.7414 49.6215 76.5073C44.9617 78.2733 39.8544 78.4781 35.0682 77.0909C30.282 75.7037 26.0757 72.7996 23.0824 68.8156C20.0891 64.8316 18.4707 59.9832 18.4707 55C18.4707 50.0168 20.0891 45.1684 23.0824 41.1844C26.0757 37.2004 30.282 34.2963 35.0682 32.9091C39.8544 31.5219 44.9617 31.7267 49.6215 33.4927C54.2813 35.2587 58.2415 38.4902 60.9062 42.7011C58.4178 39.9322 55.1481 37.9832 51.5288 37.1115C47.9095 36.2398 44.1109 36.4865 40.6348 37.819C37.1586 39.1514 34.1684 41.507 32.0591 44.5745C29.9497 47.642 28.8205 51.2772 28.8205 55C28.8205 58.7228 29.9497 62.358 32.0591 65.4255C34.1684 68.4931 37.1586 70.8486 40.6348 72.1811C44.1109 73.5135 47.9095 73.7602 51.5288 72.8885C55.1481 72.0168 58.4178 70.0678 60.9062 67.2989Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15692_297394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138,
    height: 92,
    fill: "white",
    transform: "translate(-4.5293 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagTurkDestination);
export default __webpack_public_path__ + "static/media/flagTurkDestination.579323247a6dc92ca0db7dcf4de2dd90.svg";
export { ForwardRef as ReactComponent };